import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { Observable, catchError, throwError } from "rxjs";
import { ErrorMessageService } from "../services/error-message.service";
import { SystemHealthService } from "src/app/shared/services/system-health.service";
import { MatDialog } from "@angular/material/dialog";
import { InformationDialogComponent } from "src/app/shared/components/information-dialog/information-dialog.component";

const SERVICE_UNAVAILABLE_STATUSES = [0, 500, 502, 503];
@Injectable({
  providedIn: "root",
})
export class LoggingInterceptor implements HttpInterceptor {
  private errorCount = 0;
  private lastErrorTime = 0;
  constructor(
    private router: Router,
    private errorService: ErrorMessageService,
    private systemHealth: SystemHealthService,
    private matDialog: MatDialog
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Don't block requests based on systemHealth.isDown() during init
    // This was preventing the app from loading at all in anonymous mode
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // A missing affiliate profile is the expected registration-screen state.
        // Keep propagating the error so callers can finish loading and reset status.
        if (
          req.method === "GET" &&
          /\/Affiliate\/dashboard\/?(?:\?|$)/.test(req.url) &&
          error.status === 404
        ) {
          return throwError(() => error);
        }

        if (SERVICE_UNAVAILABLE_STATUSES.includes(error.status)) {
          const now = Date.now();
          if (now - this.lastErrorTime > 5000) {
            this.errorCount = 0;
          }
          this.errorCount++;
          this.lastErrorTime = now;

          if (this.errorCount >= 3) { //remove errorPage
            // this.systemHealth.markDown();
            // this.router.navigateByUrl("/service-unavailable");
            return throwError(() => error);
          }
        }

        if (req.url.includes("/Stylist/UploadDesign") && error.error?.message) {
          return throwError(() => error);
        }

        const msg = this.errorService.resolveErrorMessage(error, "");

        if (msg) {
          this.matDialog.open(InformationDialogComponent, {
            width: '400px',
            data: {
              title: 'Lỗi',
              message: msg,
              type: 'error'
            }
          });
        }

        return throwError(() => error);
      })
    );
  }
}
